import { Feature, Polygon } from "geojson";
import turf from "../../../../shared/utils/turf";
import { roadAndPathLayers } from "../../../utils/mapbox";
import { importHlaUtils } from "../utils";

const minimumLineLength = 10;

type BBox = [mapboxgl.Point, mapboxgl.Point];

function pixelBBoxToLonLat(bbox: BBox, map: mapboxgl.Map): Feature<Polygon> {
  const { x: minX, y: minY } = bbox[0];
  const { x: maxX, y: maxY } = bbox[1];

  const sw = map.unproject([minX, maxY]);
  const ne = map.unproject([maxX, minY]);

  return turf.bboxPolygon([sw.lng, sw.lat, ne.lng, ne.lat]);
}

export function queryRoadAndPathLayers(bbox: BBox, map: mapboxgl.Map) {
  const bboxPolygon = pixelBBoxToLonLat(bbox, map);

  const features = importHlaUtils
    .flattenLineAndMultiLineFeatures(
      map.queryRenderedFeatures(bbox, {
        layers: roadAndPathLayers,
      }),
    )
    .filter((f) => turf.booleanIntersects(f, bboxPolygon))
    .filter((f) => turf.length(f, { units: "meters" }) >= minimumLineLength);

  console.log("Lines we found (already filtered and isolated):", features);

  return features;
}
